import * as i from "react";
import { forwardRef as d, useContext as E } from "react";
import g from "./index648.mjs";
import { getRegisteredStyles as C, registerStyles as h, insertStyles as P } from "./index556.mjs";
import { serializeStyles as S } from "./index558.mjs";
import { useInsertionEffectAlwaysWithSyncFallback as w } from "./index557.mjs";
var u = /* @__PURE__ */ i.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ g({
    key: "css"
  }) : null
), A = u.Provider, y = function(r) {
  return /* @__PURE__ */ d(function(a, e) {
    var n = E(u);
    return r(a, n, e);
  });
}, N = /* @__PURE__ */ i.createContext({}), v = {}.hasOwnProperty, l = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", F = function(r, a) {
  var e = {};
  for (var n in a)
    v.call(a, n) && (e[n] = a[n]);
  return e[l] = r, e;
}, T = function(r) {
  var a = r.cache, e = r.serialized, n = r.isStringTag;
  return h(a, e, n), w(function() {
    return P(a, e, n);
  }), null;
}, x = /* @__PURE__ */ y(function(t, r, a) {
  var e = t.css;
  typeof e == "string" && r.registered[e] !== void 0 && (e = r.registered[e]);
  var n = t[l], m = [e], o = "";
  typeof t.className == "string" ? o = C(r.registered, m, t.className) : t.className != null && (o = t.className + " ");
  var f = S(m, void 0, i.useContext(N));
  o += r.key + "-" + f.name;
  var c = {};
  for (var s in t)
    v.call(t, s) && s !== "css" && s !== l && (c[s] = t[s]);
  return c.className = o, a && (c.ref = a), /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(T, {
    cache: r,
    serialized: f,
    isStringTag: typeof n == "string"
  }), /* @__PURE__ */ i.createElement(n, c));
}), L = x;
export {
  A as C,
  L as E,
  N as T,
  F as c,
  v as h,
  y as w
};
